<template>
  <div class="column_center_around table_order_container">
    <text class="title">桌號</text>
    <text class="table_number">{{ table }}</text>
    <button class="button" @click="click">開始點餐</button>
  </div>
</template>
<script>
export default {
  computed: {
    getUrlParameters() {
      return this.$route.params
    },
    dineInTables() {
      return this.$store.getters['spreadsheet/dineInTables']
    },
    table() {
      return this.$store.getters['spreadsheet/tableName'](this.areaId, this.tableIndex)
    },
    areaId() {
      return this.getUrlParameters.areaId
    },
    tableIndex() {
      return this.getUrlParameters.tableIndex === undefined || this.getUrlParameters.tableIndex == '' ? -1 : this.getUrlParameters.tableIndex
    },
    isAreaIdValid() {
      return this.$store.getters['spreadsheet/isAreaIdValid'](this.areaId)
    },
    isTableIndexValid() {
      return this.$store.getters['spreadsheet/isTableIndexValid'](this.areaId, this.tableIndex)
    }
  },
  methods: {
    click() {
      this.$emit('click')
    }
  },
};
</script>
<style lang="scss" scoped>
.table_order_container {
  width: 92%;
  padding: 20px 8vw;
  background-color: #fff;
  border-radius: 6px;
  flex-shrink: 0;
  margin: 20px 0 0;
  flex-shrink: 0;
}

.table_number {
  font-size: 56px;
  font-weight: 600;
  font-family: PingFang SC;
  color: #fd5001;
  flex-shrink: 0;
  margin: 0 0 10px;
}
</style>
